/**
 * @ngdoc service
 * @name checkins.factory:deleteSelected
 *
 * @description
 *
 */
angular
    .module('festzelt-os.components')
    .factory('deleteSelected', [
        deleteSelected
    ]);

function deleteSelected() {
    return {
        key: 'delete-selected',
        title: 'Permanently delete selected',
        level: 'archivedSelected',
        manager: 'deleteMany'
    }
}



// WEBPACK FOOTER //
// ./src/app/components/workflows/general/delete-selected.js